export default {
  plans: [],
  chosenPlan: {},
};



// WEBPACK FOOTER //
// ./src/app/store/modules/plan/state.js